// extracted by mini-css-extract-plugin
module.exports = {"uniBlue":"#00adef","cityCard":"cityCard-module--city-card--3bzTx","cityCard__description":"cityCard-module--city-card__description--1Y-Pt"};